import io from 'socket.io-client';
import GlobalURL from './baseUrl';
// const URL = "https://smashing-shrew-peaceful.ngrok-free.app";
// const URL = "https://clean-penguin-constantly.ngrok-free.app";

// Establish the socket connection.
export const socket = io(GlobalURL, {
    autoConnect: false,
    transports: ["websocket"]
});